import buildRoutes from 'ember-engines/routes';
export default buildRoutes(function () {
  this.route('create', function () {
    this.route('cluster');
  });
  this.route('detail', {
    path: '/:name'
  }, function () {
    this.mount('snapshots', {
      path: '/snapshots'
    });
    this.route('replication', function () {
      this.route('index', {
        path: '/'
      });
      this.route('create');
      this.route('path-filters');
    });
    this.route('metrics', function () {
      this.route('configure');
    });
    this.route('audit-logs', function () {
      this.route('index', {
        path: '/'
      });
      this.route('configure');
    });
    this.route('edit', function () {
      this.route('index', {
        path: '/'
      });
      this.route('review');
    });
    this.route('settings', function () {
      this.route('index', {
        path: '/'
      });
      this.route('edit');
    });
    this.route('cluster-networking', function () {
      this.route('index', {
        path: '/'
      });
      this.route('aws-privatelink');
      this.route('edit');
      this.route('edit-proxy');
      this.route('edit-cluster-accessibility');
    });
    this.route('integrations', function () {
      this.route('index', {
        path: '/'
      });
    });
    this.route('plugins');
    this.route('registry', function () {
      this.mount('vault-registry', {
        as: 'vault-registry',
        path: '/',
        resetNamespace: false
      });
    });
  });
  this.route('clusters', function () {
    this.route('list', {
      path: '/'
    });
  });
  this.route('secrets-inventory');
});